import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { connect } from 'react-redux'
import { compact, map } from 'lodash'

import * as Actions from 'store/actions'
import registryReducers, {
  getIsBabylistAppInstalled as regUserInstalledApp,
  getIsMobile as regIsMobile,
} from 'registry/reducers'
import { filterByAvailable } from 'store/lib'
import activeSortParams from './active-sort-params'
import categories from './categories'
import registryProductIds from './registry-product-ids'
import cartProductIds from './cart-product-ids'
import { productFiltersReducer } from '../components/product-filters/reducers'

// BL-6143 Borrow user reducer from registry app

export const getIsBabylistAppInstalled = regUserInstalledApp
export const getIsMobile = regIsMobile
export const getFeatureFlags = (state) => state.ui.featureFlags
export const ui = (state = { featureFlags: null }, action) => {
  switch (action.type) {
    case Actions.SET_IS_MOBILE:
      return { ...state, isMobile: action.isMobile }
    case Actions.SET_CASH_FUND_PREFERENCES:
      return { ...state, cashFundPreferences: action.preferences }

    default:
      return state
  }
}

export const withFeatureFlags = (/* possible future config */) => {
  const WithFeatureFlags = (WrappedComponent) =>
    connect((state, ownProps) => ({
      featureFlags: getFeatureFlags(state),
      ...ownProps,
    }))(WrappedComponent)

  return WithFeatureFlags
}

export { withActiveSortParams } from './active-sort-params'
export { withActiveProductFilters } from '../components/product-filters/reducers'

export default combineReducers({
  activeSortParams,
  cartProductIds,
  categories,
  registryProductIds,
  form,
  productFilters: productFiltersReducer,
  user: registryReducers.user,
  ui,
})

export const getCartProductIds = (state) => state.cartProductIds
export const getCashFundPreferences = (state) => state.ui.cashFundPreferences
export const getRegistryProductIds = (state) => state.registryProductIds
export const isProductOnRegistry = (state, productId) =>
  getRegistryProductIds(state).indexOf(productId) > -1

export const getCategoryBySlug = (state, slug) => state.categories[slug] || null

export const getSlugSetForSlug = (state, slug) =>
  getCategoryBySlug(state, slug) ? getCategoryBySlug(state, slug).slugSet : []

export const getCategoryWithChildrenBySlug = (state, slug) => {
  const category = getCategoryBySlug(state, slug)
  if (!category) return null
  return {
    ...category,
    children: category.children
      ? compact(
          map(category.children, (childSlug) =>
            getCategoryBySlug(state, childSlug)
          )
        )
      : null,
  }
}

export const getRegistryOwnerId = (state) => state.user.currentRegistry?.ownerId
export const getUserId = (state) => state.user.id
export const getUserEmail = (state) => state.user.email
